import React, { useEffect, useMemo, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Spin, Input, Select, Modal } from "antd";
import _ from "lodash";
import * as API from "src/api/plan";
import * as REQ from "src/api/request";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { FilterMatchMode } from "primereact/api";
import { usePlanContext } from "src/contexts/planContext";
import MODAL from "src/pages/company/modal";
// import { useUserContext } from "src/contexts/userContext";
import axios from "axios";
import dayjs from "dayjs";
import AddBtn from "src/components/button/plusButton";
import useBearStore from "src/state/state";
import Swal from "sweetalert2";
import register from "../workers/register";
import * as XLSX from "xlsx";

const Workers = () => {
  const { state, dispatch } = usePlanContext();
  const daysInMonth = new Date(
    moment(state.report.date).format("YYYY"),
    moment(state.report.date).format("MM"),
    0,
  ).getDate(); // June has 30 days
  const main_company_id = useBearStore((state) => state.main_company_id);
  const group_id = useBearStore((state) => state.group_id);
  const user_id = useBearStore((state) => state.user_id);
  const userInfo = useBearStore((state) => state.userInfo);
  const [ssum_total, setssum_total] = useState(0);
  const [sum_cash, setsum_cash] = useState(0);
  const groupData_list = {};
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          "https://tugeelt.store/api/backend/report",
          // "http://tugeelt.store/api/backend/report",
          // "http://localhost:5000/api/backend/report",
          {
            params: {
              sub_code: state.balance.seller_id,
              start_date: moment(state.report.date).format("YYYY.MM.01"),
              end_date: moment(state.report.date).format(
                "YYYY.MM." + daysInMonth,
              ),
            },
          },
        );

        const rawData = response.data.response;
        console.log(rawData);
        // ✅ Group and sum by delguur_id + delguur_ner
        const groupedData = Object.values(
          rawData.reduce((acc, item) => {
            const key = `${item.delguur_id}_${item.delguur_ner}_${item.cash}`;

            if (!acc[key]) {
              acc[key] = {
                delguur_id: item.delguur_id,
                delguur_ner: item.delguur_ner,
                cash: item.cash,
                total: 0,
              };
            }

            acc[key].total += Number(item.total) || 0; // add up totals safely
            return acc;
          }, {}),
        );

        console.log("groupdata-----", groupedData);

        response.data.response.forEach((item) => {
          const mainGroup = item.src_company_ner || "Бусад";
          const subGroup = item.company_name || "No Name";
          const total = item.count * item.price;

          if (!groupData_list[mainGroup]) {
            groupData_list[mainGroup] = {};
          }

          if (!groupData_list[mainGroup][subGroup]) {
            groupData_list[mainGroup][subGroup] = 0;
          }

          groupData_list[mainGroup][subGroup] += total;
        });
        const cleanedData = _.mapKeys(groupData_list, (value, key) =>
          key.trim(),
        );
        console.log("group data", cleanedData);
        dispatch({
          type: "STATE",
          data: {
            gg_list: cleanedData,
          },
        });
        console.log("fetcha dataaa", groupData_list);

        var result = _(response.data.response)
          .groupBy("id_order")
          .map(function (items, id_order) {
            return {
              order_id: id_order,
              delguur_id: items[0].delguur_id,
              delguur_ner: items[0].delguur_ner,
              register_date: moment(items[0].register_date).format(
                "YYYY.MM.DD",
              ),
              cash: items[0].cash,
              count: _.sumBy(items, "count"),
              total: _.sumBy(items, "total"),
              user_name: items[0].user_name,
              phone: items[0].phone,
              is_approve: items[0].is_approve,
              is_print: items[0].is_print,
              print_date: items[0].print_date,
              is_dist: items[0].is_dist,
              dist_date_register: items[0].dist_date_register,
            };
          })
          .value();
        var ssum = 0;
        _.map(result, (item) => {
          ssum += item.total;
        });
        setssum_total(ssum);
        var cashsum = 0;
        _.map(result, (item) => {
          cashsum += item.cash;
        });
        setsum_cash(cashsum);
        dispatch({
          type: "STATE",
          data: {
            balance_list: response.data.response,
            balanceGroup_list: result,
          },
        });

        setList(
          _.orderBy(
            _.filter(response.data.response, (a) => a.id !== null),
            ["id"],
          ),
        );

        setLoading(false);
      } catch (error) {
        setLoading(false);
        // setError(error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.refresh, state.report.date, state.balance.seller_id]);

  const exportToExcel = () => {
    const worksheetData = [
      ["№", "Дэлгүүр нэр", ...daysArray, "Бэлэн", "Нийт", "Зээл"],
    ];
    const styles = [];
    storeNames.forEach((delguur_ner, index) => {
      const row = [
        index + 1,
        delguur_ner,
        ...groupedData[delguur_ner].days.map(({ total, cash }) => {
          if (total !== null) {
            const balance = total - cash;
            // Add styling info for conditional formatting
            styles.push(
              balance > 0 ? { color: "FF0000" } : { color: "000000" },
            );
            return total + ", \nБ:" + cash;
          }
          return "";
        }),

        groupedData[delguur_ner].sumCash,
        groupedData[delguur_ner].sumTotal,

        groupedData[delguur_ner].sumTotal - groupedData[delguur_ner].sumCash,
      ];
      worksheetData.push(row);
    });

    // const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    // XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    // XLSX.writeFile(workbook, "export.xlsx");

    const workbook = XLSX.utils.book_new();
    // const worksheet = XLSX.utils.json_to_sheet([]);
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    // XLSX.utils.sheet_add_aoa(worksheet, Heading, { origin: "A1" });
    // XLSX.utils.sheet_add_json(worksheet, result, {
    //   origin: "A2",
    //   skipHeader: true,
    // });
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(
      workbook,
      "Тайлан -" + moment().format("YYYY_MM_сар") + ".xlsx",
      {
        compression: true,
      },
    );
  };
  const aggregateData = _.orderBy(state.balanceGroup_list, [
    "delguur_ner",
  ]).reduce((acc, { delguur_ner, register_date, total, cash, is_approve }) => {
    const key = `${delguur_ner}-${register_date}`;
    if (!acc[key]) {
      acc[key] = { delguur_ner, register_date, total, cash, is_approve };
    } else {
      acc[key].total += total;
      acc[key].cash += is_approve === 1 ? total : cash;
    }
    return acc;
  }, {});

  const aggregatedDataArray = Object.values(aggregateData);

  const groupedData = aggregatedDataArray.reduce(
    (acc, { delguur_ner, register_date, total, cash, is_approve }) => {
      if (!acc[delguur_ner]) {
        acc[delguur_ner] = {
          days: Array(daysInMonth).fill({ total: null, balance: null }),
          sumTotal: 0,
          sumCash: 0,
        };
      }
      const day = new Date(register_date).getDate() - 1;
      acc[delguur_ner].days[day] = { total, cash, is_approve };
      acc[delguur_ner].sumTotal += total;
      acc[delguur_ner].sumCash += cash;

      // acc[delguur_ner].sumCash += is_approve === 1 ? total : cash;
      return acc;
    },
    {},
  );

  const [search, setSearch] = useState({
    global: { value: "", matchMode: FilterMatchMode.CONTAINS },
  });
  const [first, set_first] = useState(0);
  const [per_page, set_per_page] = useState(50);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  const storeNames = Object.keys(groupedData);
  const isUserValid = useBearStore((state) => state.isUserValid);
  const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  const deleteClick = (item) => {
    try {
      const response = axios.delete(
        // "http://tugeelt.store/api/backend/company/" + item.id
        "http://tugeelt.store/api/backend/company/" + item.id,
      );
      dispatch({
        type: "STATE",
        data: { refresh: state.refresh + 1 },
      });
    } catch (error) {
      setLoading(false);
    }
  };
  // const cleanedData = _.mapValues(groupData_list, (companyMap) =>
  //   _.mapKeys(companyMap, (value, key) => key.trim())
  // );
  return (
    <div className="w-full">
      {" "}
      <Modal
        style={{ width: "600" }}
        width={800}
        height={550}
        visible={state.company.modal}
        // visible={true}
        onCancel={() => dispatch({ type: "COMPANY", data: { modal: false } })}
        closeIcon={<div className="">x</div>}
        footer={false}
      >
        <MODAL />
      </Modal>
      <div className="flex items-center space-x-2 mb-4">
        <img
          alt=""
          title="Excel татах"
          src="/img/excel.png"
          className="w-[30px] h-8 object-cover cursor-pointer hover:scale-125 duration-300"
          onClick={() => exportToExcel()}
        />
        <div className="flex items-center">
          Нийт борлуулалт:{" "}
          <span
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              color: "blue",
            }}
          >
            {Intl.NumberFormat("en-US").format(ssum_total)}
          </span>
          {" |  "}
          Бэлэн:{" "}
          <span
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              color: "green",
            }}
          >
            {Intl.NumberFormat("en-US").format(sum_cash)}
          </span>
          {" |  "}
          Зээл:{" "}
          <span
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              color: "red",
            }}
          >
            {Intl.NumberFormat("en-US").format(ssum_total - sum_cash)}
          </span>{" "}
        </div>
      </div>
      <Spin tip="Уншиж байна." className="bg-opacity-80" spinning={loading}>
        <div
          style={{
            maxWidth: "100%",
            overflowX: "auto", // Enable horizontal scrolling
            paddingBottom: "50px", // Add padding to avoid scroll bar being clipped
          }}
        >
          <div className="space-y-6">
            {Object.entries(state.gg_list).map(([groupName, companies]) => (
              <div
                key={groupName}
                className="border border-gray-200 rounded-xl shadow-sm p-4 bg-white"
              >
                <h2 className="text-xl font-semibold text-gray-800 mb-3">
                  {groupName}
                </h2>
                <ul className="space-y-1 pl-4 text-gray-700">
                  {Object.entries(companies)
                    .sort(([aName], [bName]) => aName.localeCompare(bName))
                    .map(([companyName, total]) => (
                      <li key={companyName} className="flex border-b pb-1">
                        <span className="text-lg w-[350px] truncate">
                          {companyName}
                        </span>
                        <span className="text-lg ml-2">
                          {total.toLocaleString()}
                        </span>
                      </li>
                    ))}
                </ul>
              </div>
            ))}

            {/* <div className="border-t pt-4 text-right">
              <h3 className="text-lg font-bold text-gray-900">
                Нийт дүн:{" "}
                {Object.values(state.gg_list)
                  .flatMap((companies) => Object.values(companies))
                  .reduce((acc, val) => acc + val, 0)
                  .toLocaleString()}{" "}
                ₮
              </h3>
            </div> */}
          </div>

          <table
            className="pivot-table"
            style={{
              width: "100%", // Ensures the table fills the container
              minWidth: "800px", // Ensures the table has a minimum width
            }}
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Дэлгүүр нэр</th>
                {daysArray.map((day) => (
                  <th key={day}>{day}</th>
                ))}
                <th>Бэлэн</th>
                <th>Нийт</th>
                <th>Зээл</th>
              </tr>
            </thead>
            <tbody>
              {storeNames.map((delguur_ner, index) => (
                <tr key={delguur_ner}>
                  <td>{index + 1}</td>
                  <td style={{ textAlign: "left" }}>{delguur_ner}</td>
                  {groupedData[delguur_ner].days.map(
                    ({ total, cash }, index) => (
                      <td
                        key={index}
                        style={{
                          backgroundColor:
                            total - cash > 0 ? "red" : "transparent",
                          color: "black", // Optional: Adjust text color for better contrast
                        }}
                      >
                        {total !== null && cash !== null ? (
                          <div>
                            <div>
                              {Intl.NumberFormat("en-US").format(total)}
                            </div>
                            <div>
                              Б: {Intl.NumberFormat("en-US").format(cash)}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    ),
                  )}

                  <td style={{ fontWeight: "bold" }}>
                    {Intl.NumberFormat("en-US").format(
                      groupedData[delguur_ner].sumCash,
                    )}
                  </td>
                  <td
                    style={{
                      backgroundColor:
                        groupedData[delguur_ner].sumTotal -
                          groupedData[delguur_ner].sumCash >
                        0
                          ? "red"
                          : "transparent",
                    }}
                  >
                    {Intl.NumberFormat("en-US").format(
                      groupedData[delguur_ner].sumTotal,
                    )}
                  </td>

                  <td style={{ fontWeight: "bold" }}>
                    {Intl.NumberFormat("en-US").format(
                      groupedData[delguur_ner].sumTotal -
                        groupedData[delguur_ner].sumCash,
                    )}
                  </td>
                </tr>
              ))}
              <tr>
                <td colspan={daysInMonth + 3}>...</td>
              </tr>
              <tr>
                <td colspan={daysInMonth + 3}>...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Spin>
    </div>
  );
};

export default React.memo(Workers);
